import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=12b55088&"
import script from "./RoleEdit.vue?vue&type=script&lang=js&"
export * from "./RoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=12b55088&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports